import React, { useState } from 'react';
import { translate } from '../Services/translation';
import InputField from './InputField';
import { string, object } from 'yup';
import { error as errorReducer } from '../Reducers/Error.reducer';
import constants from '../constants';
import { post } from '../Services/http';
import { useDispatch } from 'react-redux';
import { addFlashMessage } from '../Actions/FlashMessages.action';
import { catchErrorNoDispatch } from '../Actions/Error.action';
import { handleApiErrors } from '../Services/Error.service';

const NewsletterSignUpForm = ({onSubmitted, signupComponentName}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState([])
    const dispatch = useDispatch();

    const emailValidationSchema = object().shape({
        email: string()
            .required(translate('js.newslettersignup.validation.email.notempty'))
            .email(translate('js.newslettersignup.validation.email.notvalid')),
    });

    const submit = () => {
        setIsSubmitting(true);

        emailValidationSchema.validate({
            email,
        })
        .then(async () => {
            let recaptchaToken = await runReCaptcha(constants.reCaptchaPublicKey, 'submit');

            post('/api/user/newsletterSignup', {email, recaptchaToken, signupComponentName})
                .then(() => {
                    onSubmitted();
                })
                .catch((ex) => {
                    catchErrorNoDispatch(ex, (error) => {
                        dispatch(handleApiErrors(error));
                        setErrors(error);
                    })
                    setIsSubmitting(false);
                });
        })
        .catch((error) => {
            setErrors(errorReducer(errors, {type: '', payload: {error}}));
            setIsSubmitting(false);
        })
    }

    return (
        <form>
            <div>
                <InputField
                    id='email'
                    name='email'
                    type='text'
                    value={email}
                    onChange={(value) => setEmail(value)}
                    disabled={isSubmitting}
                    errors={errors}
                />
            </div>
            <div>
                <button type="button" className={`button button__primary ${isSubmitting ? 'loading' : ''}`} disabled={isSubmitting} onClick={() => submit()}>
                    {translate('js.newslettersignup.button.signup')}
                    <span className="spinner spinner--light spinner--small"></span>
                </button>
            </div>
        </form>
    );
};

export default NewsletterSignUpForm;
